import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

interface Props {
  hoverable?: boolean
  padding?: 'sm' | 'md' | 'lg' | 'xl'
  customClass?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseCard',
  props: {
    hoverable: { type: Boolean, default: false },
    padding: { default: 'md' },
    customClass: { default: '' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'bg-white dark:bg-gray-800 rounded-2xl shadow-lg border border-gray-200 dark:border-gray-700',
      'transition-all duration-300',
      _ctx.hoverable && 'hover:shadow-xl hover:scale-[1.02]',
      _ctx.padding === 'sm' && 'p-4',
      _ctx.padding === 'md' && 'p-6',
      _ctx.padding === 'lg' && 'p-8',
      _ctx.padding === 'xl' && 'p-10',
      _ctx.customClass
    ])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})